import { FAMILY_LABELS_EXPORT } from '@gorampe/catalog-adapter';

interface Props {
  search: string;
  onSearchChange: (s: string) => void;
  activeFamily: string | null;
  onFamilyChange: (f: string | null) => void;
  familyCounts: Map<string, number>;
  totalCount: number;
  onlyPriced: boolean;
  onOnlyPricedChange: (v: boolean) => void;
}

export function CatalogFilters({
  search,
  onSearchChange,
  activeFamily,
  onFamilyChange,
  familyCounts,
  totalCount,
  onlyPriced,
  onOnlyPricedChange,
}: Props) {
  return (
    <div className="flex flex-col gap-3 pb-3 sm:flex-row sm:items-center sm:flex-wrap">
      <input
        type="search"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Recherche SKU ou nom..."
        className="rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 sm:w-64"
        aria-label="Recherche dans le catalogue"
      />
      <label className="flex items-center gap-2 text-sm text-slate-700">
        <input
          type="checkbox"
          checked={onlyPriced}
          onChange={(e) => onOnlyPricedChange(e.target.checked)}
          className="h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-200"
        />
        Seulement avec prix
      </label>
      <div className="flex flex-wrap gap-1.5">
        <button
          type="button"
          onClick={() => onFamilyChange(null)}
          className={`rounded-full px-3 py-1 text-xs font-medium transition ${
            activeFamily === null
              ? 'bg-slate-800 text-white'
              : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
          }`}
        >
          Tous <span className="opacity-60">({totalCount})</span>
        </button>
        {Object.entries(FAMILY_LABELS_EXPORT).map(([code, label]) => {
          const count = familyCounts.get(code) ?? 0;
          if (count === 0) return null;
          return (
            <button
              key={code}
              type="button"
              onClick={() => onFamilyChange(code)}
              className={`rounded-full px-3 py-1 text-xs font-medium transition ${
                activeFamily === code
                  ? 'bg-slate-800 text-white'
                  : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
              }`}
            >
              {code === 'other' ? label : `${code} ${label}`}{' '}
              <span className="opacity-60">({count})</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
